module.exports = __webpack_public_path__ + "img/logo-beta.97d0fc8c.svg";